import { cn } from "../../ui";
export const MenuPopup = ({ isOpen, className, children, }) => (<div className={cn("menuPopup shadow-dark-100 absolute left-0 z-10 w-full overflow-hidden border-t border-gray-light bg-white shadow-md", className, isOpen ? "block" : "hidden")}>
        <div>{children}</div>
    </div>);
